import React, { FC, useContext, StyleHTMLAttributes } from 'react'
import { RadioGroupContext } from 'components/RadioButton/RadioGroup'
import styles from './PointStyleRadio.module.scss'
import { Icon } from 'components/Icon'
import { useId } from '@reach/auto-id'

type PointStyleRadioProps = {
  icon: string
  label: string
  value?: string
  style?: StyleHTMLAttributes<HTMLDivElement>
}

export const PointStyleRadio: FC<PointStyleRadioProps> = ({ value, label, icon, ...other }) => {
  const id = useId()
  const ctx = useContext(RadioGroupContext)

  return (
    <div className={styles.pointStyleRadio} {...other}>
      <input
        id={id}
        type="radio"
        name="point_style"
        checked={value === ctx.value}
        value={value}
        onChange={ctx.handleChange}
      />
      <label htmlFor={id}>
        <Icon name={icon} />
        <span>{label}</span>
      </label>
    </div>
  )
}

PointStyleRadio.displayName = 'PointStyleRadio'
